export default __webpack_public_path__ + "static/media/silly2.61add894.png";